"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CommonRichText = void 0;
var _commonRichText = _interopRequireDefault(require("./components/common-rich-text"));
exports.CommonRichText = _commonRichText["default"];